import { render, staticRenderFns } from "./newOilCost.vue?vue&type=template&id=85e5b2bc&scoped=true&"
import script from "./newOilCost.vue?vue&type=script&lang=js&"
export * from "./newOilCost.vue?vue&type=script&lang=js&"
import style0 from "./newOilCost.vue?vue&type=style&index=0&id=85e5b2bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85e5b2bc",
  null
  
)

export default component.exports